import {
  customInstanceWithHeader,
  type ResponseWithHeaders,
} from '@fukuri-admins/apis/client/base/axiosInstance';
import {
  getGetApiV1ThreeLetterCodeClientAdminsClientAdminUsersKey,
  getGetApiV1ThreeLetterCodeClientAdminsClientAdminUsersUrl,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type {
  GetApiV1ThreeLetterCodeClientAdminsClientAdminUsers200,
  GetApiV1ThreeLetterCodeClientAdminsClientAdminUsersParams,
} from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';
import type { KeyedMutator } from 'swr';

const fetcher = (
  threeLetterCode: string,
  apiParams: GetApiV1ThreeLetterCodeClientAdminsClientAdminUsersParams
) =>
  customInstanceWithHeader<GetApiV1ThreeLetterCodeClientAdminsClientAdminUsers200>(
    getGetApiV1ThreeLetterCodeClientAdminsClientAdminUsersUrl(threeLetterCode, apiParams),
    { method: 'GET' }
  );

type Args = {
  threeLetterCode: string;
  page?: string;
};

type IUseGetClientAdminUsers = (args: Args) => {
  data: GetApiV1ThreeLetterCodeClientAdminsClientAdminUsers200;
  totalPage: number;
  totalCount: number;
  mutate: KeyedMutator<ResponseWithHeaders<GetApiV1ThreeLetterCodeClientAdminsClientAdminUsers200>>;
};

/**
 * 管理者ユーザー一覧取得フック
 */
export const useGetClientAdminUsers: IUseGetClientAdminUsers = ({ threeLetterCode, page }) => {
  const apiParams: GetApiV1ThreeLetterCodeClientAdminsClientAdminUsersParams = {
    ...(page && !Number.isNaN(Number(page)) && { page: Number(page) }),
  };

  const { data, mutate } = useFetch<
    ResponseWithHeaders<GetApiV1ThreeLetterCodeClientAdminsClientAdminUsers200>
  >(
    getGetApiV1ThreeLetterCodeClientAdminsClientAdminUsersKey(threeLetterCode, apiParams),
    () => fetcher(threeLetterCode, apiParams),
    { suspense: true }
  );

  const totalPage = Number(data.headers['total-pages']) || 0;
  const totalCount = Number(data.headers['total-count']) || 0;

  return {
    data: data.data,
    totalPage,
    totalCount,
    mutate,
  };
};
